import { Notify } from 'quasar';

export default function Notifier(message, type) {
  return Notify.create({
    message,
    type,
    position: 'top',
  });
}
